import React from 'react';

export type FinanceiroTab = 'entradas' | 'saidas' | 'extrato' | 'fluxo' | 'cobrancas' | 'gateways' | 'bancos';

interface FinanceiroTabsNavigationProps {
  activeTab: FinanceiroTab;
  onTabChange: (tab: FinanceiroTab) => void;
  entradasCount: number;
  saidasCount: number;
  cobrancasCount: number;
  gatewaysCount: number;
  bancosCount: number;
}

export function FinanceiroTabsNavigation({
  activeTab,
  onTabChange,
  entradasCount,
  saidasCount,
  cobrancasCount,
  gatewaysCount,
  bancosCount,
}: FinanceiroTabsNavigationProps) {
  return (
    <div className="border-b border-slate-200 flex gap-4 overflow-x-auto pb-px">
      <button
        type="button"
        onClick={() => onTabChange('entradas')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer ${
          activeTab === 'entradas'
            ? 'border-emerald-600 text-emerald-700'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        <span className="w-2.5 h-2.5 rounded-full bg-emerald-500"></span>
        Contas a Receber ({entradasCount})
      </button>

      <button
        type="button"
        onClick={() => onTabChange('saidas')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer ${
          activeTab === 'saidas'
            ? 'border-rose-600 text-rose-700'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        <span className="w-2.5 h-2.5 rounded-full bg-rose-500"></span>
        Contas a Pagar ({saidasCount})
      </button>

      <button
        type="button"
        onClick={() => onTabChange('extrato')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap flex items-center gap-2 cursor-pointer ${
          activeTab === 'extrato'
            ? 'border-indigo-600 text-indigo-700'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        <span className="w-2.5 h-2.5 rounded-full bg-indigo-600"></span>
        Extrato por CNPJ & Banco
      </button>

      <button
        type="button"
        onClick={() => onTabChange('fluxo')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap cursor-pointer ${
          activeTab === 'fluxo'
            ? 'border-slate-900 text-slate-900'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        Fluxo de Caixa
      </button>

      <button
        type="button"
        onClick={() => onTabChange('cobrancas')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap cursor-pointer ${
          activeTab === 'cobrancas'
            ? 'border-slate-900 text-slate-900'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        Cobranças ({cobrancasCount})
      </button>

      <button
        type="button"
        onClick={() => onTabChange('gateways')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap cursor-pointer ${
          activeTab === 'gateways'
            ? 'border-slate-900 text-slate-900'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        Gateways ({gatewaysCount})
      </button>

      <button
        type="button"
        onClick={() => onTabChange('bancos')}
        className={`pb-3 px-2 text-sm font-bold border-b-2 transition-colors whitespace-nowrap cursor-pointer ${
          activeTab === 'bancos'
            ? 'border-slate-900 text-slate-900'
            : 'border-transparent text-slate-500 hover:text-slate-800'
        }`}
      >
        Bancos ({bancosCount})
      </button>
    </div>
  );
}
